// extracted by mini-css-extract-plugin
export default {"label_div":"Style_label_div__S4OgD"};